import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-h5 mt-1" }, "Количество талонов по категориям граждан", -1)

import { computed } from 'vue'
import {
  AddUsedCardsStat,
  UpdateUsedCardsStat,
  CitizenCategory,
  UsedCardsStat,
  citizenCategoryName,
  SalesPointsService,
  AppAuthService,
  Permissions,
} from '@prodcard/core'
import { useWatcherSavedRef } from '../../../../helpers'
import { useAuthPermissions } from '../../../../mixins'
import { VSalesPointsSelect } from '../../../../components'
import useVuelidate, { ErrorObject } from '@vuelidate/core'
import { required, helpers, minValue, integer } from '@vuelidate/validators'
import { mapValues } from 'lodash'

interface Props {
  salesPointsService: SalesPointsService
  authService: AppAuthService
  usedCardsStat?: UsedCardsStat
  loading?: boolean
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UsedCardsStatForm',
  props: {
    salesPointsService: {},
    authService: {},
    usedCardsStat: {},
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['onSubmit'],
  setup(__props: any, { emit }) {

const props = __props;



const { hasPermissions, currentMunicipalEntityId } = useAuthPermissions(props.authService)
const hasManage = computed(() => hasPermissions(Permissions.USED_CARDS_STATS_MANAGE))
const hasMeManage = computed(() => hasPermissions(Permissions.ME_USED_CARDS_STATS_MANAGE))



const usedCardsStatOpts = useWatcherSavedRef<AddUsedCardsStat>('UsedCardStatForm', {
  dataEntryDate: new Date(),
  salesPointId: '',
  values: mapValues(CitizenCategory, () => 0),
})

const dataEntryDate = computed(() => {
  if (usedCardsStatOpts.value.dataEntryDate) {
    const date = new Date(usedCardsStatOpts.value.dataEntryDate)
    return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`
  }
  return undefined
})

const rules = computed(() => ({
  salesPointId: {
    required: helpers.withMessage('Торговый объект не может быть пустым', required),
  },
  dataEntryDate: {
    required: helpers.withMessage('Дата внесения данных не может быть пустой', required),
  },
  values: mapValues(CitizenCategory, () => ({
    minValue: helpers.withMessage('Значение не может быть меньше 0', minValue(0)),
    integer: helpers.withMessage('Значение не может быть дробным', integer),
  })),
}))

const validator = useVuelidate<UpdateUsedCardsStat>(rules, usedCardsStatOpts)

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) {
    usedCardsStatOpts.value.dataEntryDate = new Date()
    emit('onSubmit', usedCardsStatOpts.value)
  }
}

const getErrorMessages = (errors: ErrorObject[]) => {
  return errors.map((e: ErrorObject) => e.$message).join(', ')
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(submit, ["prevent"]),
    disabled: _ctx.loading || _ctx.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                "model-value": dataEntryDate.value,
                label: "Дата внесения данных",
                readonly: ""
              }, null, 8, ["model-value"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(VSalesPointsSelect), {
                modelValue: _unref(usedCardsStatOpts).salesPointId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(usedCardsStatOpts).salesPointId) = $event)),
                "sales-points-service": _ctx.salesPointsService,
                "additional-filter-data": {
            municipalEntityId: !hasManage.value && hasMeManage.value ? _unref(currentMunicipalEntityId) : undefined,
          },
                "error-messages": getErrorMessages(_unref(validator).salesPointId.$errors),
                label: "Торговый объект*",
                disabled: _ctx.disabled || _ctx.loading
              }, null, 8, ["modelValue", "sales-points-service", "additional-filter-data", "error-messages", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CitizenCategory), (citizenCategory) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: citizenCategory,
              cols: "12",
              md: [_unref(CitizenCategory).P_F, _unref(CitizenCategory).P_M].includes(citizenCategory) ? 6 : 4
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  "model-value": _unref(usedCardsStatOpts).values[citizenCategory] || undefined,
                  label: _unref(citizenCategoryName)(citizenCategory),
                  "error-messages": getErrorMessages(_unref(validator).values[citizenCategory].$errors),
                  type: "number",
                  placeholder: "0",
                  "onUpdate:modelValue": value => (_unref(usedCardsStatOpts).values[citizenCategory] = value ? Number(value) : 0)
                }, null, 8, ["model-value", "label", "error-messages", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1032, ["md"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.loading,
                disabled: _ctx.disabled
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onSubmit", "disabled"]))
}
}

})